module.exports = __webpack_public_path__ + "static/img/12.821fe85.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/12.png
// module id = W6cw
// module chunks = 1